import React from 'react'
import { Navigate, Outlet } from "react-router";

const ProtectedRoute = ({allowedRoles}) => {
    const token    = localStorage.getItem("jwtToken");
    const userType = localStorage.getItem("userType");

    if(!token || !allowedRoles.includes(userType))
        return <Navigate to = "/" replace/>
    
    return <Outlet />;
}

export default ProtectedRoute
